<template>
  <div :class="$style.categoriesBlock">
    <h2>{{ data.title }}</h2>
    <flicking
      hide-before-init
      :plugins="plugins"
      viewport-tag="div"
      camera-tag="div"
      :camera-class="$style.flickingBanner"
      :options="{ bound: true }"
    >
      <div
        v-for="(category, index) in data.categories"
        :id="String(index)"
        :key="index"
        :class="$style.categoryCard"
        @click="openLink(category.linkTo)"
      >
        <div :class="$style.categoryCardInside">
          <img :class="$style.categoryCardImg" :src="category.icon.url" />
          <span :class="$style.categoryCardTitle">
            {{ category?.title || '' }}
            <ArrowBackIcon :class="$style.categoryCardArrow" />
          </span>
          <span :class="$style.categoryCardDescription">{{ category?.description || '' }}</span>
        </div>
      </div>
      <template #viewport>
        <div v-if="isPaginationShown" :class="$style.categoriesBlockControll">
          <div class="flicking-pagination" />
          <div class="flicking-arrow-prev" />
          <div class="flicking-arrow-next" />
        </div>
      </template>
    </flicking>
  </div>
</template>

<script lang="ts" setup>
import { Arrow, Pagination } from '@egjs/flicking-plugins';
import Flicking from '@egjs/vue3-flicking';
import { onMounted, ref } from 'vue';
import ArrowBackIcon from '~/public/images/common/eva_arrow-back-fill.svg?component';
import { useStoreRoot } from '~/stores/abstract/root';
import '@egjs/vue3-flicking/dist/flicking.css';
import type { ComponentInfoPageBlocksCategoriesBlock } from '~/types/infoPages';

const props = defineProps({
  data: {
    type: Object as PropType<ComponentInfoPageBlocksCategoriesBlock>,
    required: true,
  },
});

const storeRoot = useStoreRoot();

const plugins = [new Pagination({ type: 'bullet' }), new Arrow()];

const isPaginationShown = ref(true);

const openLink = (link: string) => {
  return navigateTo({
    path: `${storeRoot.domainLang ? '/' + storeRoot.domainLang : ''}${link}`,
  });
};

onMounted(() => {
  const lastCard = document.getElementById(String(props.data.categories.length - 1));
  let isLastCardInViewport = false;

  if (lastCard) {
    const lastCardRect = lastCard.getBoundingClientRect();

    isLastCardInViewport =
      lastCardRect.left >= 0 &&
      lastCardRect.right <= (window.innerWidth || document.documentElement.clientWidth);
  }

  isPaginationShown.value = !isLastCardInViewport;
});
</script>

<style lang="scss" module src="./categoriesBlock.scss"></style>
